export default "__VITE_ASSET__DBGt1cnz__"